import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { ItemSelectorModule } from '../item-selector.module';
import { ItemSelectorDialogComponent } from './item-selector-dialog.component';

export const ITEM_SELECTOR_DIALOG_MODULE_IMPORTS = [
  CommonModule,
  MatDialogModule,
  MatButtonModule,
  ItemSelectorModule,
  LexiconModule,
  TranslateModule,
];
export const ITEM_SELECTOR_DIALOG_MODULE_DECLARATIONS = [ItemSelectorDialogComponent];

@NgModule({
  imports: ITEM_SELECTOR_DIALOG_MODULE_IMPORTS,
  exports: [ItemSelectorDialogComponent],
  declarations: ITEM_SELECTOR_DIALOG_MODULE_DECLARATIONS,
})
export class ItemSelectorDialogModule {}
